const ProductCategoryList = [
  {
    name: 'Furniture',
    group: 'Home and Garden',
  },
  {
    name: 'Lighting',
    group: 'Home and Garden',
  },
  {
    name: 'Decor',
    group: 'Home and Garden',
  },
  {
    name: 'Textiles',
    group: 'Home and Garden',
  },
  {
    name: 'Garden',
    group: 'Home and Garden',
  },
  {
    name: 'Clothing',
    group: 'Clothing and Accessories',
  },
  {
    name: 'Footwear',
    group: 'Clothing and Accessories',
  },
  {
    name: 'Accessories',
    group: 'Clothing and Accessories',
  },
  {
    name: 'Jewelry',
    group: 'Jewelry and Watches',
  },
  {
    name: 'Watches',
    group: 'Jewelry and Watches',
  },
  {
    name: 'Makeup & Cosmetics',
    group: 'Beauty and Health',
  },
  {
    name: 'Fragrances & Perfumes',
    group: 'Beauty and Health',
  },
  {
    name: 'Personal Hygiene Products',
    group: 'Beauty and Health',
  },
  {
    name: 'Oral Care Products',
    group: 'Beauty and Health',
  },
  {
    name: 'Men’s Shaving & Grooming Products',
    group: 'Beauty and Health',
  },
  {
    name: 'Massage & Relaxation Devices',
    group: 'Beauty and Health',
  },
  {
    name: 'Medical & First Aid Supplies',
    group: 'Beauty and Health',
  },
  {
    name: 'Kitchen Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Laundry & Garment Care Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Cleaning Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Climate Control Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Personal Care Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Smart Home & Security Appliances',
    group: 'Home Appliances',
  },
  {
    name: 'Audio & Headphones',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Smartphones & Accessories',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Computers & Laptops',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Cameras & Photography Equipment',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Gaming & Entertainment Gadgets',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Health & Fitness Gadgets',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Office & Productivity Gadgets',
    group: 'Electronics and Gadgets',
  },
  {
    name: 'Outdoor Gear & Equipment',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Cycling & Biking Equipment',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Fitness & Exercise Equipment',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Water Sports & Activities',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Team Sports Equipment',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Climbing & Hiking Gear',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Winter Sports Equipment',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Hunting & Fishing Gear',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Protective Gear & Accessories',
    group: 'Sports and Outdoor Activities',
  },
  {
    name: 'Fast Food & Takeout',
    group: 'Food Delivery',
  },
  {
    name: 'Sushi & Asian Cuisine',
    group: 'Food Delivery',
  },
  {
    name: 'Sandwiches',
    group: 'Food Delivery',
  },
  {
    name: 'Salads & Bowls',
    group: 'Food Delivery',
  },
  {
    name: 'Breakfast & Brunch',
    group: 'Food Delivery',
  },
  {
    name: 'Desserts & Sweets',
    group: 'Food Delivery',
  },
];

export default ProductCategoryList;
